import { render, staticRenderFns } from "./myPMR.vue?vue&type=template&id=d33beb90&scoped=true&"
import script from "./myPMR.vue?vue&type=script&lang=js&"
export * from "./myPMR.vue?vue&type=script&lang=js&"
import style0 from "./myPMR.vue?vue&type=style&index=0&id=d33beb90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33beb90",
  null
  
)

export default component.exports